import { render, staticRenderFns } from "./NoConversations.vue?vue&type=template&id=33c67b97"
import script from "./NoConversations.vue?vue&type=script&lang=js"
export * from "./NoConversations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports